(ns lupapalvelu.ui.application.foreman-util
  (:require [sade.util :as util]))

(defn foreman-item->tj-document
  "Returns the foreman document for the given foreman item (items are returned by foreman-applications query
   and generated by foreman-application-info and foreman-application-info-for-v3).

  At this point there is only one foreman document per item, so we can just find the first one.
  For the v2-types we need to enrich the data with some application level data."
  [foreman-item]
  (->> foreman-item
       :documents
       (util/find-first #(-> % :schema-info :name keyword #{:tyonjohtaja-v2 :tyonjohtaja-v3}))))

(defn foreman-item->tj-role [{:keys [lupapiste-role] :as foreman-item}]
  (or lupapiste-role
      (some->> foreman-item foreman-item->tj-document :data :kuntaRoolikoodi :value keyword)))

(defn termination-req-allowed
  [{:keys [doc-state foreman-is-current-user is-authority is-applicant
           ended termination command-authorized]}]
  (let [ended (or ended (:ended termination))
        now   (js/Date.now)]
    (and command-authorized
         (or is-authority
             is-applicant
             foreman-is-current-user)
         (contains? #{"acknowledged" "declared" "ok" "foremanVerdictGiven" "approved"} doc-state)
         (not= (:state termination) "requested")
         (not (and ended (< ended now))))))
